import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateStorageMutation } from '../../features/fullApi';

export default function EditStorageDialog({openEdit, setOpenEdit, handleUpdateStorage, item, message}) {

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateStorage] = useUpdateStorageMutation()
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          amount: item?.amount,
          type: item?.type
        },
      });

    return (
        <form onSubmit={handleSubmit} >
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenEdit(false)} open={openEdit}>
                <DialogTitle id='dialog-title'>
                    Edit Storage
                </DialogTitle>

                <DialogContent>
                    <DialogContentText style={{color: "red"}}>You are editing storage {item.amount} {item.type}</DialogContentText>
                    <TextField
                        id="amount"
                        type="text"
                        margin="dense"
                        value={values.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.amount ? "" : "Amount"}
                    />
                    {errors.amount && touched.amount && (
                        <p className="error">{errors.amount}</p>
                    )}

                    <FormControl fullWidth style={{marginTop: '10px'}}>
                        <InputLabel id="type">Type</InputLabel>
                            <Select
                                labelId="type"
                                id="type"
                                value={values.type}
                                label="Type"
                                onChange={handleChange}
                                name="type"
                            >
                                <MenuItem value={"MB"}>MB</MenuItem>
                                <MenuItem value={"GB"}>GB</MenuItem>
                                <MenuItem value={"TB"}>TB</MenuItem>
                            </Select>
                    </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateStorage({id: item, amount: values.amount, type: values.type})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}